@if (mode === 'buttons') {
  @for (
    option of visibleOptions;
    track trackOption(index, option);
    let index = $index
  ) {
    <div
      class="option"
      (click)="pick(index)"
      [ngClass]="{ picked: option.picked }"
      [zalamoTooltip]="option.description | langPicker | async"
    >
      @if (iconMode) {
        <div class="icon">
          @if (option.icon) {
            <img [src]="option.icon | publicImageUrl: 200 : 200 | async" />
          }
          @if (!option.icon) {
            <div></div>
          }
        </div>
      }
      <span>
        {{ option.label | langPicker | async }}
      </span>
    </div>
  }
}
@if (mode === 'select') {
  <mat-form-field libZalamoField>
    <mat-select [formControl]="control">
      <mat-option [value]="null" translate>select</mat-option>
      @for (option of visibleOptions; track option; let index = $index) {
        <mat-option [value]="option.paramId">
          {{ option.label | langPicker | async }}
        </mat-option>
      }
    </mat-select>
    <lib-zalamo-field-decoration></lib-zalamo-field-decoration
  ></mat-form-field>
}
